// Code generated by @sumup/sumup-ts-codegen. DO NOT EDIT.

import {
  APIResource,
  type RequestOptions,
  type WithResponse,
} from "../../core";
import type { Metadata, Role } from "../../types";
export type ListMerchantRolesResponse = { items: Role[] };

export type CreateMerchantRoleParams = {
  /**
   * User-defined name of the role.
   */
  name: string;
  /**
   * User's permissions.
   */
  permissions: string[];
  metadata?: Metadata;
  /**
   * User-defined description of the role.
   */
  description?: string;
};

export type UpdateMerchantRoleParams = {
  /**
   * User-defined name of the role.
   */
  name?: string;
  /**
   * User's permissions.
   */
  permissions?: string[];
  /**
   * User-defined description of the role.
   */
  description?: string;
};

/**
 * API resource for the Roles endpoints.
 *
 * Endpoints to manage custom roles. Custom roles allow you to tailor roles from individual permissions to match your needs. Once created, you can assign your custom roles to your merchant account members using the memberships.
 */
export class Roles extends APIResource {
  /**
   * List merchant's custom roles.
   */
  list(
    merchantCode: string,
    options?: RequestOptions,
  ): Promise<ListMerchantRolesResponse> {
    return this._client.get<ListMerchantRolesResponse>({
      path: `/v0.1/merchants/${merchantCode}/roles`,
      ...options,
    });
  }

  listWithResponse(
    merchantCode: string,
    options?: RequestOptions,
  ): Promise<WithResponse<ListMerchantRolesResponse>> {
    return this._client.getWithResponse<ListMerchantRolesResponse>({
      path: `/v0.1/merchants/${merchantCode}/roles`,
      ...options,
    });
  }

  /**
   * Create a custom role for the merchant. Roles are defined by the set of permissions that they grant to the members that they are assigned to.
   */
  create(
    merchantCode: string,
    body: CreateMerchantRoleParams,
    options?: RequestOptions,
  ): Promise<Role> {
    return this._client.post<Role>({
      path: `/v0.1/merchants/${merchantCode}/roles`,
      body,
      ...options,
    });
  }

  createWithResponse(
    merchantCode: string,
    body: CreateMerchantRoleParams,
    options?: RequestOptions,
  ): Promise<WithResponse<Role>> {
    return this._client.postWithResponse<Role>({
      path: `/v0.1/merchants/${merchantCode}/roles`,
      body,
      ...options,
    });
  }

  /**
   * Retrieve a custom role by ID.
   */
  get(
    merchantCode: string,
    roleId: string,
    options?: RequestOptions,
  ): Promise<Role> {
    return this._client.get<Role>({
      path: `/v0.1/merchants/${merchantCode}/roles/${roleId}`,
      ...options,
    });
  }

  getWithResponse(
    merchantCode: string,
    roleId: string,
    options?: RequestOptions,
  ): Promise<WithResponse<Role>> {
    return this._client.getWithResponse<Role>({
      path: `/v0.1/merchants/${merchantCode}/roles/${roleId}`,
      ...options,
    });
  }

  /**
   * Delete a custom role.
   */
  delete(
    merchantCode: string,
    roleId: string,
    options?: RequestOptions,
  ): Promise<void> {
    return this._client.delete<void>({
      path: `/v0.1/merchants/${merchantCode}/roles/${roleId}`,
      ...options,
    });
  }

  deleteWithResponse(
    merchantCode: string,
    roleId: string,
    options?: RequestOptions,
  ): Promise<WithResponse<void>> {
    return this._client.deleteWithResponse<void>({
      path: `/v0.1/merchants/${merchantCode}/roles/${roleId}`,
      ...options,
    });
  }

  /**
   * Update a custom role.
   */
  update(
    merchantCode: string,
    roleId: string,
    body: UpdateMerchantRoleParams,
    options?: RequestOptions,
  ): Promise<Role> {
    return this._client.patch<Role>({
      path: `/v0.1/merchants/${merchantCode}/roles/${roleId}`,
      body,
      ...options,
    });
  }

  updateWithResponse(
    merchantCode: string,
    roleId: string,
    body: UpdateMerchantRoleParams,
    options?: RequestOptions,
  ): Promise<WithResponse<Role>> {
    return this._client.patchWithResponse<Role>({
      path: `/v0.1/merchants/${merchantCode}/roles/${roleId}`,
      body,
      ...options,
    });
  }
}
